import type { ServerSideConfigManager } from './use-server-side-config';
import { Snippet } from '../../../../Websites/List/ScriptsModal';
import { COPY } from './copy';

type ServerSideSnippetsProps = { manager: ServerSideConfigManager };

/** The three ways to call a server-decided experiment, filled in with its real keys. */
export const ServerSideSnippets = ({ manager }: ServerSideSnippetsProps) => {
  const { snippets, copiedText, copy, missingVariantKeys } = manager;

  return (
    <div className="flex flex-col gap-2">
      <span className="micro-label">{COPY.snippets.title}</span>
      {missingVariantKeys && <p className="supporting text-warn m-0">{COPY.snippets.missingKeys}</p>}
      <div className="grid gap-3">
        <Snippet
          title={COPY.snippets.sdkTitle}
          description={COPY.snippets.sdkDescription}
          snippet={snippets.sdk}
          isCopied={copiedText === snippets.sdk}
          onCopy={() => copy(snippets.sdk)}
        />
        <Snippet
          title={COPY.snippets.seedTitle}
          description={COPY.snippets.seedDescription}
          snippet={snippets.seed}
          isCopied={copiedText === snippets.seed}
          onCopy={() => copy(snippets.seed)}
        />
        <Snippet
          title={COPY.snippets.curlTitle}
          description={COPY.snippets.curlDescription}
          snippet={snippets.curl}
          isCopied={copiedText === snippets.curl}
          onCopy={() => copy(snippets.curl)}
        />
      </div>
    </div>
  );
};
